import { Vector2, Line, Component, UpdateContext } from "../Engine";
import { SoccerPlaygroundConfig, HalfArea, Sizes } from "./";

export class Goal extends Component {

    leftPost: Vector2 = Vector2.zero;
    rightPost: Vector2 = Vector2.zero;
    middleMarkerLine: Line | undefined;

    width: number = 0;
    height: number = 0;

    constructor(public readonly config: SoccerPlaygroundConfig, public readonly halfArea: HalfArea) {
        super();

        const realWidth = Sizes.GoalWidth;
        const realHeight = Sizes.GoalWidth / 6;

        this.width = realWidth * this.config.conversionFactor;
        this.height = realHeight * this.config.conversionFactor;

        const yCoordinate = halfArea === HalfArea.UpperArea ? this.config.topLeftCorner.y : this.config.bottomLeftCorner.y;

        this.leftPost = new Vector2(config.centerPoint.x - (this.width / 2), yCoordinate);
        this.rightPost = new Vector2(config.centerPoint.x + (this.width / 2), yCoordinate);

        const markerHeight = this.height * 0.5;
        const markerOffsetY = this.halfArea === HalfArea.UpperArea ? -markerHeight : markerHeight;
        this.middleMarkerLine = new Line(
            new Vector2(this.config.centerPoint.x, yCoordinate), 
            new Vector2(this.config.centerPoint.x, yCoordinate + markerOffsetY)
        );

        this.children.push(this.middleMarkerLine);
    }
    public update(updateContext: UpdateContext): void {
        super.update(updateContext);
    }

    public draw(ctx: CanvasRenderingContext2D) {
        ctx.restore();
        this.drawGoal(ctx);

        super.draw(ctx);
    }

    private drawGoal(ctx: CanvasRenderingContext2D) {
        ctx.beginPath();
        ctx.fillStyle = 'lightgray';
        const offsetY = this.halfArea === HalfArea.UpperArea ? -this.height : 0;
        ctx.fillRect(this.leftPost.x, this.leftPost.y + offsetY, this.width, this.height);
        ctx.strokeRect(this.leftPost.x, this.leftPost.y + offsetY, this.width, this.height);
        ctx.fillStyle = 'black';
    }



}